<template>
    <div class="modal-overlay">
        <div class="modal">
            <div class="modal-content" id="session-expired">
                <div class="modal-header">
                    <h2>Session Expiration</h2>
                </div>
                <div class="modal-main-content">
                    <p>You have left this browser idle for 15 minutes.</p>
                    <p>{{ time / 1000 }} seconds left before you're logged out automatically.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { onLogout } from '@/utils/helpers'

    export default {
        data() {
            return {
                time: 30000
            }
        },
        created() {
            let timerId = setInterval(() => {
                this.time -= 1000
                if (!this.$store.state.idleVue.isIdle) clearInterval(timerId)

                if (this.time < 1) {
                    clearInterval(timerId)
                    onLogout(this)
                }
            }, 1000)
        }
    }
</script>